/**
 * MPP Theme Adapter
 * Single responsibility: listen to mpp:selectionChanged, call Theme JS.
 * This is the ONLY file allowed to touch window.theme.ProductOptions.
 * If the theme changes, only this file needs updating.
 */
(function() {
  'use strict';

  if (window.MPPThemeAdapter) return;
  window.MPPThemeAdapter = true;

  function getProductContainer(productId) {
    // Find the [data-js-product] container that wraps the MPP options
    var optionsEl = document.querySelector('[data-mpp-options][data-product-id="' + productId + '"]');
    if (!optionsEl) return null;
    if (window.jQuery) {
      var $p = jQuery(optionsEl).closest('[data-js-product]');
      return $p.length ? $p : null;
    }
    return null;
  }

  function applyVariant(productId, variant) {
    if (!window.jQuery) return;
    if (!window.theme || !window.theme.ProductOptions) {
      setTimeout(function() { applyVariant(productId, variant); }, 50);
      return;
    }

    var $product = getProductContainer(productId);
    if (!$product) return;

    var dataJson = $product.find('.data-json-product').first();
    var jsonRaw  = dataJson.length ? dataJson.html() : null;

    // _loadJSON reads the full product JSON (with variants_metafields, countdown etc.)
    // _switchVariant drives the complete Theme update chain:
    // price, button, gallery, history, SKU, barcode, availability
    window.theme.ProductOptions._loadJSON($product, jsonRaw, function(json) {
      window.theme.ProductOptions._switchVariant($product, {
        update_variant:       variant,
        json:                 json,
        has_unselected_options: false,
        dontUpdateVariantsSelect: true
      });
    });
  }

  document.addEventListener('mpp:selectionChanged', function(e) {
    var d = e.detail;
    if (!d || !d.productId) return;

    // Only push to theme when selection is fully complete and variant is found
    if (d.state === 'available' || d.state === 'sold_out' || d.state === 'inquiry') {
      applyVariant(d.productId, d.variant);
    }
    // 'incomplete' and 'invalid' states: theme keeps current state, no update
  });

})();
